import React, { useState } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import Select from "react-select"
import moment from "moment"
import ProductionSummaryAction from "store/production-summary/actions"
import TableJacket from "./TableJacket"
import TableTrousers from "./TableTrousers"
import { ProductionSummaryUtil } from "util/ProductionSummary"
import Skeleton from "react-loading-skeleton"

export default function ProductionAmount() {
  const dispatch = useDispatch()
  const history = useHistory()
  const store = useSelector(state => state)

  const [filter, setFilter] = useState({
    year: moment().year(),
    month: `${moment().month() + 1} 月`,
  })

  React.useEffect(() => {
    const payload = Object.assign({}, filter)
    payload.month = payload.month.match(/\d/g)

    dispatch(ProductionSummaryAction.getList(payload))
  }, [filter])

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title={"制作高"} breadcrumbList={[]} />
        <Card>
          <CardBody>
            <Row>
              <Col md={3}>
                <Select
                  options={ProductionSummaryUtil.getListYear()}
                  defaultValue={{
                    value: filter.year,
                    label: filter.year,
                  }}
                  value={{
                    value: filter.year,
                    label: filter.year,
                  }}
                  onChange={e => {
                    setFilter({
                      ...filter,
                      year: e.value,
                    })
                  }}
                />
              </Col>
              <Col md={3}>
                <Select
                  options={ProductionSummaryUtil.getListMonth()}
                  defaultValue={{
                    value: filter.month,
                    label: filter.month,
                  }}
                  value={{
                    value: filter.month,
                    label: filter.month,
                  }}
                  onChange={e => {
                    setFilter({
                      ...filter,
                      month: e.value.match(/\d/g)[0],
                    })
                  }}
                />
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <Row className="mt-3">
              <Col>
                {store.productionSummary.list.loading ? (
                  <Skeleton count={5} />
                ) : (
                  <>
                    {!store.productionSummary.list.data?.pants?.length &&
                    !store.productionSummary.list.data?.jackets?.length ? (
                      <p>データが見つかりません</p>
                    ) : (
                      <>
                        <TableTrousers />
                        <TableJacket />
                      </>
                    )}
                  </>
                )}
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}

// import React from "react"
// import { Col, Container, Row } from "reactstrap"
// import Breadcrumbs from "../../components/Common/Breadcrumb"
// import Select from "react-select"
// import TableTrousers from "./TableTrousers"
// import TableJacket from "./TableJacket"

// const ProductionAmount = () => {
//   return (
//     <>
//       <div className="page-content">
//         <Container fluid>
//           <Breadcrumbs title={"制作高"} breadcrumbItem={`制作高`} />
//           <Row className="mb-3">
//             <Col sm="4">
//               <Select />
//             </Col>
//             <Col sm="4">
//               <Select />
//             </Col>
//           </Row>
//           <Row className="mb-3">
//             <Col sm="12">
//               <TableTrousers
//                 content={[
//                   {
//                     creator_name: '小倉 友美',
//                     production_number_bespoke: '50',
//                     production_amount_bespoke: '1,000,000',
//                     production_number_mtm: '2',
//                     production_amount_mtm: '140,000',
//                     production_number_rtw: '20',
//                     production_amount_rtw: '60,000',
//                     production_number_repair: '0',
//                     production_amount_repair: '0',
//                     production_number_sample: '0',
//                     production_amount_sample: '0',
//                     production_number_total: '72',
//                     production_amount_total: '1,000,000'
//                   },
//                   {
//                     creator_name: '駒田 結加',
//                     production_number_bespoke: '40',
//                     production_amount_bespoke: '800,000',
//                     production_number_mtm: '2',
//                     production_amount_mtm: '140,000',
//                     production_number_rtw: '0',
//                     production_amount_rtw: '0',
//                     production_number_repair: '0',
//                     production_amount_repair: '0',
//                     production_number_sample: '0',
//                     production_amount_sample: '0',
//                     production_number_total: '42',
//                     production_amount_total: '800,000'
//                   },
//                   {
//                     creator_name: '巻下 善明',
//                     production_number_bespoke: '50',
//                     production_amount_bespoke: '1,050,000',
//                     production_number_mtm: '2',
//                     production_amount_mtm: '140,000',
//                     production_number_rtw: '20',
//                     production_amount_rtw: '60,000',
//                     production_number_repair: '0',
//                     production_amount_repair: '0',
//                     production_number_sample: '1',
//                     production_amount_sample: '10,000',
//                     production_number_total: '73',
//                     production_amount_total: '1,050,000'
//                   },
//                   {
//                     creator_name: '北村 浩太郎',
//                     production_number_bespoke: '40',
//                     production_amount_bespoke: '850,000',
//                     production_number_mtm: '2',
//                     production_amount_mtm: '140,000',
//                     production_number_rtw: '20',
//                     production_amount_rtw: '0',
//                     production_number_repair: '0',
//                     production_amount_repair: '0',
//                     production_number_sample: '1',
//                     production_amount_sample: '5,000',
//                     production_number_total: '43',
//                     production_amount_total: '850,000'
//                   },
//                   {
//                     creator_name: '北村 浩太郎、駒田結加',
//                     production_number_bespoke: '2',
//                     production_amount_bespoke: '100,000',
//                     production_number_mtm: '',
//                     production_amount_mtm: '',
//                     production_number_rtw: '',
//                     production_amount_rtw: '',
//                     production_number_repair: '',
//                     production_amount_repair: '',
//                     production_number_sample: '',
//                     production_amount_sample: '',
//                     production_number_total: '2',
//                     production_amount_total: '100,000'
//                   },
//                 ]}
//               />
//             </Col>
//           </Row>
//           <Row className="mb-3">
//             <Col sm="12">
//               <TableJacket
//                 content={[
//                   {
//                     creator_name: '松村 至',
//                     production_number_bespoke: '50',
//                     production_amount_bespoke: '1,050,000',
//                     production_number_mtm: '2',
//                     production_amount_mtm: '140,000',
//                     production_number_rtw: '20',
//                     production_amount_rtw: '60,000',
//                     production_number_repair: '0',
//                     production_amount_repair: '0',
//                     production_number_sample: '1',
//                     production_amount_sample: '10,000',
//                     production_number_total: '73',
//                     production_amount_total: '1,050,000'
//                   },
//                   {
//                     creator_name: '山上',
//                     production_number_bespoke: '40',
//                     production_amount_bespoke: '850,000',
//                     production_number_mtm: '2',
//                     production_amount_mtm: '140,000',
//                     production_number_rtw: '0',
//                     production_amount_rtw: '0',
//                     production_number_repair: '0',
//                     production_amount_repair: '0',
//                     production_number_sample: '1',
//                     production_amount_sample: '5,000',
//                     production_number_total: '43',
//                     production_amount_total: '850,000'
//                   },
//                 ]}
//               />
//             </Col>
//           </Row>
//         </Container>
//       </div>
//     </>
//   )
// }

// export default ProductionAmount
